import { useCallback, useEffect, useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { axiosPath } from '../../routing/helpers/router';
import * as moduleAction from '../../store/actions/moduleAction';

const LanguageSelector = ({ style = {} }) => {
  const dispatch = useDispatch();
  const moduleBridgeHex = useSelector(
    (state) => state.global?.route?.params?.moduleBridgeHex,
  );
  const global = useSelector((state) => state.global);
  const module = useSelector((state) => state.module);
  const [actualLang, setActualLang] = useState();
  const [languages, setLanguages] = useState([]);

  // < STORE CALLS
  const loadModuleLanguages = useCallback(
    async (req) => {
      try {
        await dispatch(
          moduleAction.fetch(
            axiosPath('api_r_user_global_getLanguages'),
            'lang',
            req,
          ),
        );
      } catch (err) {}
    },
    [moduleBridgeHex],
  );

  useEffect(() => {
    if (module && moduleBridgeHex && !module[moduleBridgeHex])
      loadModuleLanguages({ moduleBridgeHex });
  }, [moduleBridgeHex]);
  // < STORE CALLS

  // < LANGUAGE LIST SELECTION
  useEffect(() => {
    if (moduleBridgeHex) {
      if (module?.[moduleBridgeHex]?.lang)
        setLanguages(module[moduleBridgeHex].lang);
    } else if (global.languages) setLanguages(global.languages);
  }, [global, module]);
  // < LANGUAGE LIST SELECTION

  // < LANGUAGE REDIRECTION
  useEffect(() => {
    if (languages.length > 0) {
      const al = languages.find(
        (lang) => lang.slug === localStorage.getItem('locale'),
      );
      if (!al) {
        localStorage.setItem('locale', languages[0].slug);
        window.location.reload();
      } else {
        setActualLang(al);
      }
    }
  }, [languages]);
  // < LANGUAGE REDIRECTION

  return (
    <Dropdown as="li" className="nav-item dropdown" style={style} align="end">
      <Dropdown.Toggle
        as="a"
        variant="default"
        id="dd-lang-menu"
        className="nav-link"
      >
        {actualLang && actualLang.name}
      </Dropdown.Toggle>
      <Dropdown.Menu>
        {languages.map((lang, i) => (
          <Dropdown.Item
            as="span"
            key={lang.id}
            onClick={() => {
              localStorage.setItem('locale', lang.slug);
              window.location.reload();
            }}
          >
            {lang.name}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default LanguageSelector;
